var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
var ShopDataComponent = /** @class */ (function () {
    function ShopDataComponent(navCtrl, comProv) {
        this.navCtrl = navCtrl;
        this.comProv = comProv;
        this.is_click = true;
        this.shop_list = [];
        this.shop_disp = [];
        this.begin = 0;
        //is_up:boolean = false;
        this.is_down = false;
        this.is_scroll = false;
        this.add_count = 20;
        this.wait_time = 500;
        this.is_pc = this.comProv.isPc();
        if (this.comProv.isAndroid()) {
            this.wait_time = 100;
        }
    }
    ShopDataComponent.prototype.ngOnChanges = function (changes) {
        if (changes['shop_list']) {
            if (this.is_pc) {
                this.shop_disp = this.shop_list;
                return;
            }
            // 初期化
            this.shop_list = changes['shop_list'].currentValue;
            var brand_list_1 = this.comProv.getBrandList();
            this.shop_list.forEach(function (item) {
                item['brand_image'] = null;
                if (item['brand_id']) {
                    var brand_data = brand_list_1.find(function (value) {
                        return (value['id'] == item['brand_id']);
                    });
                    if (brand_data) {
                        item['brand_image'] = brand_data['image_url'];
                    }
                }
            });
            this.begin = 0;
            this.shop_disp = [];
            this.shop_disp = this.shop_list.slice(this.begin, this.begin + this.add_count);
            this.begin += this.add_count;
            this.checkAdd();
        }
    };
    /*doUp(infiniteScroll) {
      if (this.begin <= (this.add_count * 2)) {
        infiniteScroll.complete();
        return;
      }
      if (this.is_scroll) {
        infiniteScroll.complete();
        return;
      }
      this.is_scroll = true;
      console.log('doUp', this.begin);
      setTimeout(() => {
        // 追加
        let add_list = this.shop_list.slice(this.begin - (this.add_count * 3), (this.begin - this.add_count * 2));
        add_list.reverse();
        for (let i=0; i<add_list.length; i++) {
          this.shop_disp.unshift(add_list[i]);
        }
        
        // 削除
        if (this.shop_disp.length > (this.add_count * 2)) {
          this.shop_disp.splice((this.add_count * 2), this.add_count);
        }
  
        // スクロール制御
        this.begin -= this.add_count;
        this.checkAdd();
        infiniteScroll.complete();
        this.is_scroll = false;
      }, this.wait_time)
    }*/
    ShopDataComponent.prototype.doDown = function (infiniteScroll) {
        var _this = this;
        if (this.shop_list.length <= this.begin) {
            infiniteScroll.complete();
            return;
        }
        if (this.is_scroll) {
            infiniteScroll.complete();
            return;
        }
        this.is_scroll = true;
        console.log('doDown', this.begin);
        setTimeout(function () {
            // 追加
            var add_list = _this.shop_list.slice(_this.begin, _this.begin + _this.add_count);
            for (var i = 0; i < add_list.length; i++) {
                _this.shop_disp.push(add_list[i]);
            }
            // 削除
            /*if (this.begin > this.add_count) {
              for (let i=0; i<this.add_count; i++) {
                this.shop_disp.shift();
              }
            }*/
            // スクロール制御
            _this.begin += _this.add_count;
            _this.checkAdd();
            infiniteScroll.complete();
            _this.is_scroll = false;
        }, this.wait_time);
    };
    ShopDataComponent.prototype.checkAdd = function () {
        /*if (this.begin > (this.add_count * 2)) {
          this.is_up = true;
        } else {
          this.is_up = false;
        }*/
        if (this.shop_list.length > this.begin) {
            this.is_down = true;
        }
        else {
            this.is_down = false;
        }
    };
    ShopDataComponent.prototype.goDetail = function (shop_data) {
        if (this.is_top) {
            return;
        }
        this.navCtrl.push('ShopDetailPage', {
            shop_data: shop_data,
            shop_id: shop_data['id']
        });
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], ShopDataComponent.prototype, "shop_list", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Boolean)
    ], ShopDataComponent.prototype, "is_top", void 0);
    ShopDataComponent = __decorate([
        Component({
            selector: 'shop-data',
            templateUrl: 'shop-data.html'
        }),
        __metadata("design:paramtypes", [NavController,
            CommonProvider])
    ], ShopDataComponent);
    return ShopDataComponent;
}());
export { ShopDataComponent };
//# sourceMappingURL=shop-data.js.map


// WEBPACK FOOTER //
// ./src/components/shop-data/shop-data.ts.pre-build-optimizer.js